import axios from 'axios';

const API_URL = 'https://8000-6d9dd101-fae1-458b-bde6-8ad3024d48f7.h1101.daytona.work/api/v1'; // Updated backend URL

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export const registerUser = (userData) => api.post('/auth/register', userData);
export const loginUser = (userData) => api.post('/auth/login', userData);

export const createBooking = (bookingData) => api.post('/bookings/', bookingData);
export const getMyBookings = () => api.get('/bookings/me');
export const getAvailableSlots = (date) => api.get(`/bookings/available_slots?date=${date}`);

export const createCheckoutSession = (bookingId) => api.post(`/payments/create-checkout-session/${bookingId}`);

export const getAllBookings = () => api.get('/bookings/');
export const updateBookingStatus = (bookingId, status) => api.put(`/bookings/${bookingId}`, { status });

export default api;